import styled from "styled-components";

import { chevronDown } from "assets/icons";

export const FAQContainer = styled.div`
  position: relative;
  .wrapper .header {
    display: block;
  }
  .accordion {
    padding: 0px 18px;

    /* Custom icons for FAQ accordion */
    --bs-accordion-btn-icon: url("${chevronDown}");
    --bs-accordion-btn-active-icon: url("${chevronDown}");
    --bs-accordion-btn-icon-width: 14px;
    --bs-accordion-btn-color: #181d27;

    .accordion-item {
      .accordion-header {
        border-radius: 0;

        .accordion-button {
          border-radius: 0;
          margin-bottom: 0;
          font-weight: 400;
          font-family: "Geist", sans-serif;
          font-size: 14px;
          color: #161616;
          line-height: 20px;
        }
      }

      button {
        font-weight: 400;
        font-size: 14px;
        padding: 10px;
        border-radius: 0;
        background: ${({ theme }) => theme.card.bg.primary};
      }
    }
  }
`;
export const HelpCenterSubCardContainer = styled.div`
  border: 1px solid rgba(10, 13, 18, 0.1);
  border-radius: 16px;
  .wrapper {
    padding: 0;

    .bug-description-input {
      textarea {
        border-radius: 10px;
      }
    }

    .header {
      padding: 20px;
      border-bottom: 1px solid rgba(10, 13, 18, 0.1);

      h2 {
        margin-bottom: 0;
        font-weight: 500;
        font-size: 14px;
        color: #181d27;
        font-family: "Geist", sans-serif;
        line-height: 20px;
      }
        p{
        color:#535862;
        font-size: 12px;
        font-family: "Geist", sans-serif;
        font-weight: 400;
        margin-bottom: 0;
        }


    }

  @media screen and (max-width: 768px) {
    .wrapper .header {
      h2 {
        width: 90%;
      }
    }
  }
`;
